import { Router } from 'vue-router';
import { usePortalStateStore } from '@/plugins/stores';

export default class NavigationHelper {
  public static async openForm(router: Router, form: string, queryParams = {}) {
    const portalStateStore = usePortalStateStore();
    portalStateStore.$patch({ form });
    if (Object.keys(queryParams).length === 0) {
      await router.push({ name: form });
    } else {
      await router.push({ name: form, query: queryParams });
    }
  }
}
